import { styled } from "@mui/material/styles";
import { Box, Rating, Typography } from "@mui/material";

interface CustomRatingProps {
	label: string
	value: number
	error?: boolean
	onChange: (value: number) => void
}

const CustomRating = ({ label, value, error = false, onChange }: CustomRatingProps) => {
	return (
		<CustomRatingWrapper error={error ? "true" : ""}>
			<Typography variant="body1">
				{label}
			</Typography>

			<Rating size="medium"
				value={value} precision={0.5}
				onChange={(e: any, value: any) => { onChange(Number(value)) }}
			/>
		</CustomRatingWrapper>
	)
}

const CustomRatingWrapper = styled(Box)<{ error: string }>(({ theme, error = "" }) => ({
	display: "flex",
	flexDirection: "column",
	gap: theme.spacing(1),

	p: {
		color: !!error ? theme.palette.common.fourthColor : theme.palette.common.firstColor,
	}
}))

export { CustomRating };